import { formatISO, isValid, parseISO } from 'date-fns';
export function convertValueToDate(value) {
    switch (typeof value) {
        case 'number':
            return new Date(value);
        case 'string':
            return parseISO(value);
        default:
            return undefined;
    }
}
export function convertDateToValue(date, isoString) {
    if (date && isValid(date)) {
        return isoString ? formatISO(date) : date.getTime();
    }
    else {
        return undefined;
    }
}
